<template>
  <div class="page flex-col">
    <div class="group_2 flex-col">
      <div class="box_2 flex-row">
        <span class="text_7" style="cursor: pointer" @click="handleJump('/home')">首页</span>
        <img
            class="thumbnail_1"
            referrerpolicy="no-referrer"
            src="./../../assets/img/right.webp"
        />
        <span class="text_8" style="cursor: pointer" @click="handleClick(0, true)">加入我们</span>
        <img
            class="thumbnail_2"
            referrerpolicy="no-referrer"
            src="./../../assets/img/right.webp"
        />
        <span class="text_9" style="cursor: pointer" @click="handleClick(0)">企业现状</span>
        <img
            class="thumbnail_3"
            referrerpolicy="no-referrer"
            src="./../../assets/img/right.webp"
        />
        <span class="text_10">运营规划</span>
      </div>
      <div class="box_3 flex-col">
          <span class="paragraph_1">
            1、招聘储备复合型专业人才；
            <br />
            2、制定培训计划，提升团队业务能力；
            <br />
            3、长期战咯，完成管理模式，为总公司今后商业地产经营探索一个可复制的模式。
            <br />
            4、3-5年拓展签约20-50个项目
            <br />
            5、今年新增落地运营5个项目
            <br />
            6、拓展已有校园市场
            <br />
            7、细化业务指标，精准考核
            <br />
          </span>
        <div class="section_2 flex-col"></div>
      </div>
      <div class="image-text_1 flex-row justify-between" style="cursor: pointer" @click="handleClick(0)">
        <img
            class="image_3"
            referrerpolicy="no-referrer"
            src="./../../assets/img/return.webp"
        />
        <span class="text-group_1">返回</span>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      constants: {}
    };
  },
  methods: {
    handleJump(url, data = {}) {
      if (url === this.$route.path) return;
      this.$router.push({
        path: url,
        query: data
      });
      window.scrollTo(0,0);
    },
    handleClick(value, top) {
      this.$emit('select', value, top);
    }
  }
};
</script>
<style scoped lang="css" src="./assets/index.css" />
